/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-solid-svg-icons";

const ImageSelectorButton = (props) => {
    
    const { setOpen } = props;
    
    const openImageEditor = () => {
        setOpen(true);
    };
    
    return (
        <div
            className={"component-editor-image cover center"}
            style={{ width: "100%" }}
        >
            <div className='image-hover' onClick={openImageEditor}>
                <div className='inner inner-image'>
                    <FontAwesomeIcon icon={faPlus}/> Select Image
                </div>
            </div>
        </div>
    );
};

export { ImageSelectorButton };
